import confetti from 'canvas-confetti';
import { mb } from '../../../../../common/theme/mbTokens';

const DRAWER_PAPER_SELECTOR = '.MuiDrawer-paper';
const CONFETTI_COLORS = [mb.green, mb.mint, mb.clay, mb.highlight, mb.terracotta];
const CONFETTI_BURST_DELAYS_MS = [0, 400, 800];
const DRAWER_FLASH_MS = 2000;

export const celebratePayment = (origin: HTMLElement) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  const rect = origin.getBoundingClientRect();
  const burstOrigin = {
    x: (rect.left + rect.width / 2) / window.innerWidth,
    y: (rect.top + rect.height / 2) / window.innerHeight,
  };
  CONFETTI_BURST_DELAYS_MS.forEach((delay) => {
    setTimeout(() => {
      void confetti({
        particleCount: 90,
        spread: 80,
        startVelocity: 36,
        ticks: 260,
        scalar: 0.9,
        zIndex: 2000,
        colors: CONFETTI_COLORS,
        origin: burstOrigin,
      });
    }, delay);
  });
  const drawerPaper = origin.closest<HTMLElement>(DRAWER_PAPER_SELECTOR);
  drawerPaper?.animate(
    [{ backgroundColor: mb.mint }, { backgroundColor: getComputedStyle(drawerPaper).backgroundColor }],
    { duration: DRAWER_FLASH_MS, easing: 'ease-out' },
  );
};
